import React from "react";
import { HStack, Spacer } from "@chakra-ui/react";
import { Add, Remove, Rename } from "./components";

const Actions: React.FC = () => {
  return (
    <HStack spacing={4}>
      <Spacer />
      <Rename />
      <Remove />
      <Add />
    </HStack>
  );
};

export default Actions;
